import { Color, ResponsiveAttribute } from '../../../basic';
import { ISides } from '../../../configs/config';
import { GsStructBorderRadius, GsStructBorderStyle, GsStructBorderWidth, GsStructComponent, GsStructTarget } from '../component';

export interface IButtonRender {
  // The URL to redirect to when the button is clicked
  redirectUrl?: string;
  // The URL to redirect to a leaflet when the button is clicked
  leafletUrl?: string;
  // The URL to download when the button is clicked
  downloadURL?: string;
  // An external link URL when the button is clicked
  externalLink?: string;
}

export interface GsStructButtonComponent extends GsStructComponent<IButtonRender> {
  componentType: 'Button';
  /** Text inside the button */
  buttonText: string;
  /** Size of the text in px */
  textSize?: ResponsiveAttribute<number>;
  /** The target of  button in */
  buttonLinkUrlTarget: GsStructTarget;
  /**
   * The size of the button
   * @deprecated Use the inner padding and font size to control button size instead.
   */
  buttonSize?: GsStructButtonSize;
  /** The inner padding of the button */
  innerPadding?: ResponsiveAttribute<ISides>;
  /** The class for button backgroundColor */
  buttonBackgroundColor: Color;
  /** The class button text color */
  buttonTextColor: Color;
  /** The class button border color */
  buttonBorderColor: Color;
  /**The type of button for example solid or outlined button */
  buttonType: GsStructButtonType;
  /** The class for button backgroundColor (Hover State)*/
  buttonHoverBackgroundColor: Color;
  /** The class button text color (Hover State)*/
  buttonHoverTextColor: Color;
  /** The boolean to set text transform to uppercase */
  buttonTextCaps: boolean;
  /** The class for button backgroundColor (Active State) */
  buttonActiveBackgroundColor: Color;
  /** The class button text color (Active State)*/
  buttonActiveTextColor: Color;
  /** The class for button backgroundColor (Disabled State) */
  buttonDisabledBackgroundColor: Color;
  /** The class button text color (Disabled State)*/
  buttonDisabledTextColor: Color;
  /** The class for button backgroundColor (Focus State) */
  buttonFocusBackgroundColor: Color;
  /** The class button text color (Focus State)*/
  buttonFocusTextColor: Color;
  /** button link */
  buttonLinkUrl: string;
  /** The width of the border */
  borderWidth: GsStructBorderWidth;
  /** The style of the border */
  borderStyle: GsStructBorderStyle;
  /** The color of the border */
  borderColor: Color;
  /** The color of the border (Hover State) */
  borderHoverColor?: Color;
  /** The radius of the border */
  borderRadius: GsStructBorderRadius;
  /** Takes the look from the global button settings (uiElements.buttons) instead of the own style fields */
  useUiButtonSettings?: boolean;
}

/**
 * The size of the button.
 * @deprecated Use the inner padding and font size to control button size instead.
 */
export enum GsStructButtonSize {
  small = 0,
  medium = 1,
  large = 2
}

/**
 * The type of button to display.
 * - solid: A button with a solid background color.
 * - outline: A button with a transparent background and a border.
 * - ghost: A button with a transparent background and no border, often used for secondary actions.
 * - link: A button styled as a hyperlink, typically without background or border.
 */
export enum GsStructButtonType {
  solid = 0,
  outline = 1,
  ghost = 2,
  link = 3
}
